import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../lib/store";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = location.hash || window.location.hash;
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) { navigate("/"); return; }
    const session_id = m[1];

    api.post("/auth/session", { session_id })
      .then(async () => {
        window.history.replaceState({}, "", "/account");
        await refresh();
        navigate("/account", { replace: true });
      })
      .catch(() => navigate("/", { replace: true }));
  }, [location, navigate, refresh]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#090909] text-[#C9A227] font-mono-ps text-sm tracking-widest uppercase">
      Autenticazione in corso…
    </div>
  );
}
